/** Dossier Compás: Client Info | Producción (misma tabla, Kind distinto). */

export const CLIENT_INFO_KINDS = Object.freeze(["client_info", "produccion"]);

export function normalizeClientInfoKind(raw, { fallback = "client_info" } = {}) {
  const v = String(raw || "")
    .trim()
    .toLowerCase()
    .replace(/[\s-]+/g, "_");
  if (v === "produccion" || v === "production" || v === "prod") {
    return "produccion";
  }
  if (v === "client_info" || v === "clientinfo" || v === "info") {
    return "client_info";
  }
  const fb = String(fallback || "client_info")
    .trim()
    .toLowerCase();
  return fb === "produccion" ? "produccion" : "client_info";
}

export function isProduccionRow(row) {
  return normalizeClientInfoKind(row?.Kind || row?.kind) === "produccion";
}

export function isClientInfoRow(row) {
  return !isProduccionRow(row);
}
